import { useAppContext } from '../../contexts/AppContext';
import { useMemo, useRef } from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Box } from '@mui/material';
import type { Distribution } from '../../types';
import { buildPieOptions } from '../../utils/chartOptions/pie';

type Props = {
  title: string;
  data: Distribution | undefined;
  unit?: string;
  width?: string | number;
};

const PieChart = ({ title, data, unit = '%', width = undefined }: Props) => {
  const { isDarkMode } = useAppContext();
  const chartComponent = useRef(null);
  const chartOptions = useMemo(() => buildPieOptions(data, title, unit, width), [data]);

  return (
    <>
      <Box sx={{ /*display: 'flex',*/ justifyContent: 'center', pl: 1, pr: 1 }}>
        <HighchartsReact
          ref={chartComponent}
          containerProps={{ className: isDarkMode ? 'dark-chart' : '', style: { width: '100%' } }}
          highcharts={Highcharts}
          options={chartOptions}
        />
      </Box>
      {/* <pre>
        {JSON.stringify(data, null, 4)}
      </pre> */}
    </>
  );
};

export default PieChart;
